module.exports = __webpack_public_path__ + "static/media/ic_failedverification.64d843be.png";